import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputFile, normalizePublicSequence, publicFiles } from '../interfaces/input-file';
import { ListingImageComponent } from '../../listing-image/listing-image.component';

//order of the public listing: the public files of an image pool, sorted by publicSequenceNo (first = main image)
@Component({
    selector: 'app-public-image-order',
    templateUrl: './public-image-order.component.html',
    styleUrls: ['./public-image-order.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DragDropModule, MatIconModule, MatTooltipModule, ListingImageComponent]
})
export class PublicImageOrderComponent {
    readonly files = input<InputFile[] | null | undefined>([]);
    readonly editMode = input<boolean>(false);
    //all files (the whole pool) with the changed public positions
    readonly filesChange = output<InputFile[]>();

    readonly publicFiles = computed(() => publicFiles(this.files() ?? []));

    onDropped(event: CdkDragDrop<InputFile[]>): void {
        if (event.previousIndex === event.currentIndex) return;
        const ordered = this.publicFiles().slice();
        moveItemInArray(ordered, event.previousIndex, event.currentIndex);
        this.filesChange.emit((this.files() ?? []).map(f => {
            const position = ordered.indexOf(f);
            return position === -1 || f.publicSequenceNo === position ? f : { ...f, publicSequenceNo: position };
        }));
    }

    onRemove(file: InputFile): void {
        this.filesChange.emit(normalizePublicSequence((this.files() ?? []).map(f => f === file ? { ...f, publicSequenceNo: null } : f)));
    }
}
